const parseColor = (input: string): number[] | null => {
    const value = input.trim();

    let m;

    // hex 3, e.g.: #fff
    m = value.match(/^#([0-9a-f]{3})$/i);
    if (m) {
        // in three-character format, each value is multiplied by 0x11 to give an
        // even scale from 0x00 to 0xff
        return [
            parseInt(m[1].charAt(0), 16) * 0x11,
            parseInt(m[1].charAt(1), 16) * 0x11,
            parseInt(m[1].charAt(2), 16) * 0x11,
        ];
    }

    // hex 6, e.g.: #ffffff
    m = value.match(/^#([0-9a-f]{6})$/i);
    if (m) {
        return [
            parseInt(m[1].substring(0, 2), 16),
            parseInt(m[1].substring(2, 4), 16),
            parseInt(m[1].substring(4, 6), 16),
        ];
    }

    // rgb/rgba values, e.g.: rgb(255, 255, 255), rgba(255, 255, 255, 0.5)
    m = value.match(/^rgba?\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(,\s*((\d+)?(\.\d+)?)\s*)?\)$/i);
    if (m) {
        const colorArray = [parseInt(m[1], 10), parseInt(m[2], 10), parseInt(m[3], 10)];

        if (m[5]) {
            colorArray.push(Number(m[5]));
        }

        return colorArray;
    }

    return null;
};

export default parseColor;
